// extracted by mini-css-extract-plugin
export default {"welcomeBanner":"vymoBanner_welcomeBanner__eJxR9"};